import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button, Box, Grid, CircularProgress } from '@mui/material';

// lottie
import Lottie from "lottie-react";
import login from "../assets/lotties/secure-login.json";

// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
// sections
import { LoginForm } from '../sections/auth/login';
import ForgetPassword from '../sections/auth/login/ForgetPassword';
import { getAccountItem } from '../api/auth';
import CustomSnackBar from '../components/snackbar';
import { setAccountStateAction } from '../appRedux/actions/account';


// ----------------------------------------------------------------------

const LoginPage = () => {
  const dispatch = useDispatch();

  const mdUp = useResponsive('up', 'md');
  const path = window.location.pathname.split('/')[2]
  // console.log(path)

  // snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)

  const [loginState, setLoginState] = useState(true);
  const [account, setAccount] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const getAccount = async () => {
    // console.log(path);
    setIsLoading(true)
    try {
      const { data } = await getAccountItem(path);
      if (data.success) {
        setIsLoading(false)
        if (data.hospitalAccount.status !== 'active') {
          setSnackbarMessage({ msg: "Account is not active please contact admin", success: false });
          setSnackbarOpen(true);
          return
        }
        setAccount(data.hospitalAccount)
        dispatch(setAccountStateAction({
          hospitalAccount: data.hospitalAccount
        }))
        
        }
    }
    catch (e) {
      setIsLoading(false)
      // console.log(e);
    }
  }

  useEffect(() => {
    if (path && path !== 'superadmin') {
      getAccount();
    }
  }, [])

  return (
    <>
      <Helmet>
        <title> Login | Teller One </title>
      </Helmet>

      <Grid container sx={{ height: '100vh', width: '100vw' }}>
        {isLoading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <CircularProgress />
          </Box>

        ) : (
          <>
            <Grid item xs={false} sm={false} md={6} lg={6} xl={6}>
              <Box sx={{ display: { xs: "none", md: "block" }, height: '100%' }}>

                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }} >
                  <Typography variant="h3" >
                    Hi Admin, Welcome Back
                  </Typography>
                  <Lottie animationData={login} style={{ height: '60vh' }} />
                </Box>
              </Box>

            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%', }}>
                {/* {path === 'superadmin' ? <Logo /> : <img src={account.filePath} alt='logo' width='100px' height='100px' />} */}
                <Logo />               
                {(account.status === 'active' || path === 'superadmin') &&
                  <>
                    <Box sx={{ mt: 6, mb: 3 }}>
                      {loginState ? (<Typography variant="h4" gutterBottom>
                        Sign in to {path === 'superadmin' ? 'Teller One' : account.hospitalName}
                      </Typography>) : (<Typography variant="h4" gutterBottom>
                        Reset your password
                      </Typography>)
                      }
                    </Box>
                    {loginState ? <LoginForm setLoginState={setLoginState} setSnackbarOpen={setSnackbarOpen} setSnackbarMessage={setSnackbarMessage} /> : <ForgetPassword setLoginState={setLoginState} setSnackbarOpen={setSnackbarOpen} setSnackbarMessage={setSnackbarMessage} />}
                  </>}
                <Typography mt={2} color='#b3b8bf'>© Tellercomm {new Date().getFullYear()}</Typography>
              </Box>

            </Grid>
          </>
        )}

      </Grid>
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />
    </>
  );
}
export default LoginPage;